"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _constants = require("../constants/constants");
var ProductRatingsWatcher = /*#__PURE__*/function () {
  function ProductRatingsWatcher() {
    (0, _classCallCheck2["default"])(this, ProductRatingsWatcher);
    this.productRatingsObserver = null;
  }
  return (0, _createClass2["default"])(ProductRatingsWatcher, [{
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              try {
                this.observeProductRatingsChanges();
              } catch (error) {
                console.error("Error initializing ProductRatingsWatcher:", error);
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "emitProductRatingsChanges",
    value: function () {
      var _emitProductRatingsChanges = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var event;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              event = new CustomEvent(_constants.EVENT_TYPE.CUSTOM.PRODUCT_RATINGS_RENDER);
              window.dispatchEvent(event);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function emitProductRatingsChanges() {
        return _emitProductRatingsChanges.apply(this, arguments);
      }
      return emitProductRatingsChanges;
    }()
  }, {
    key: "observeProductRatingsChanges",
    value: function observeProductRatingsChanges() {
      var _this = this;
      if (this.productRatingsObserver) return;
      this.productRatingsObserver = new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          var isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
          var isProductRatingsRequest = /https:\/\/cdn\.elements\.amazon\/elements\/amazon-product-rating\/rating/.test(entry.name);
          var urlParams = new URLSearchParams(entry.name);
          var hasProductId = urlParams.has('product-id');
          if (isValidRequestType && isProductRatingsRequest && hasProductId) {
            if (entry.responseStatus === 200) {
              _this.emitProductRatingsChanges();
            }
          }
        });
      });
      this.productRatingsObserver.observe({
        entryTypes: ["resource"]
      });
    }
  }]);
}();
var _default = exports["default"] = new ProductRatingsWatcher();
//# sourceMappingURL=product-ratings-watcher.js.map
